// import { getTimeStampParameter } from 'utils/feedUtils';
import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import {
  TOI_FEED_DOMAIN,
  UNIFIED_FEED_DOMAIN_SERVICE,
  // CARDS_ARTICLESHOW_JSON_URL_V2_LITE,
} from '../../constants';
import makeRequest from '../../utils/makeRequest';

const reducerName = 'liveblog_v2';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECEIVE_DATA = createActionName('RECEIVE_DATA');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
export const RECEIVE_COUNT_DATA = createActionName('RECEIVE_COUNT_DATA');
export const RECEIVE_TIMELINE_DATA = createActionName('RECEIVE_TIMELINE_DATA');
export const RECEIVE_COMPLETE_TIMELINE_DATA = createActionName(
  'RECEIVE_COMPLETE_TIMELINE_DATA',
);
export const HANDLE_ALL_DATA_ERROR = createActionName('HANDLE_ALL_DATA_ERROR');
export const RECEIVE_TIMELINE_DATA_PAGINATION = createActionName(
  'RECEIVE_TIMELINE_DATA_PAGINATION',
);
export const RECEIVE_LISTICLE_TABS = createActionName('RECEIVE_LISTICLE_TABS');
export const RECEIVE_LISTICLE_TABS_ERROR = createActionName(
  'RECEIVE_LISTICLE_TABS_ERROR',
);
export const RECEIVE_GAME_WIDGET_DATA = createActionName(
  'RECEIVE_GAME_WIDGET_DATA',
);
export const RECEIVE_GAME_WIDGET_DATA_ERROR = createActionName(
  'RECEIVE_GAME_WIDGET_DATA_ERROR',
);
export const RECEIVE_BOARD_DATA = createActionName('RECEIVE_BOARD_DATA');
export const RECEIVE_BOARD_DATA_ERROR = createActionName(
  'RECEIVE_BOARD_DATA_ERROR',
);
export const RECEIVE_SNIPPET_TABS = createActionName('RECEIVE_SNIPPET_TABS');
export const RECEIVE_SNIPPET_TABS_ERROR = createActionName(
  'RECEIVE_SNIPPET_TABS_ERROR',
);
export const SHOW_OPEN_IN_APP = createActionName('SHOW_OPEN_IN_APP');

export const RECEIVE_CARDS_INSERT_LITE_DATA = createActionName(
  'RECEIVE_CARDS_INSERT_LITE_DATA',
);

export const HANDLE_CARDS_INSERTS_DATA_LITE_ERROR = createActionName(
  'HANDLE_CARDS_INSERTS_DATA_LITE_ERROR',
);

export const CARDCMS_LB_TABS_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/live-blog/web/'
  : 'https://cards-staging.indiatimes.com/live-blog/web/';

export const CARDCMS_SNIPPET_TABS_URL = __PROD__
  ? 'https://api-newscard.indiatimes.com/toi/topic-tree/live-blogs/'
  : 'https://cards-staging.indiatimes.com/toi/topic-tree/live-blogs/';

// action creators
function receiveLiveblogData(data) {
  return {
    type: RECEIVE_DATA,
    payload: {
      ...data,
    },
  };
}

function receiveTimelineData(data, params, newCount) {
  const finalCount = newCount || data.data.totalCount;

  return {
    type: RECEIVE_TIMELINE_DATA,
    payload: {
      timelineData: data,
      oldCount: finalCount,
      params,
    },
  };
}
function receiveCompleteTimelineData(data, params) {
  return {
    type: RECEIVE_COMPLETE_TIMELINE_DATA,
    payload: {
      timelineData: data,
      params,
    },
  };
}
function handleCompleteTimelineDataError(error) {
  return {
    type: HANDLE_ALL_DATA_ERROR,
    error,
  };
}
function receiveTimelineDataPagination(data, params, count) {
  return {
    type: RECEIVE_TIMELINE_DATA_PAGINATION,
    payload: {
      timelineData: data,
      params,
      count,
    },
  };
}

function receiveLiveblogDataCount(data) {
  return {
    type: RECEIVE_COUNT_DATA,
    payload: {
      count: data ? data.count : undefined,
    },
  };
}

function handleLiveblogDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    error,
  };
}

export function showOpenInApp(show) {
  return {
    type: SHOW_OPEN_IN_APP,
    payload: {
      show,
    },
  };
}

// function receiveCardInsertLiteData(data) {
//   return {
//     type: RECEIVE_CARDS_INSERT_LITE_DATA,
//     payload: data,
//   };
// }

// function handleCardInsertLiteDataError() {
//   return {
//     type: HANDLE_CARDS_INSERTS_DATA_LITE_ERROR,
//     payload: {},
//   };
// }

function receiveListicleTabsData(data) {
  if (data && data.tabs && data.tabs instanceof Array && data.tabs.length > 0) {
    data.tabs.forEach(tab => {
      tab.displayName = tab.label;
      tab.name = tab.label.split(' ').join('_');
      tab.type = 'dataListicle';
      tab.gaLabel = `factsheet_${tab.label}`;
    });
    return {
      type: RECEIVE_LISTICLE_TABS,
      payload: data.tabs,
    };
  }

  return {
    type: RECEIVE_LISTICLE_TABS,
    payload: [],
  };
}

function receiveGameWidgetData(data) {
  if (data && data.status === 200 && data.data) {
    const resultData = data.data;
    return {
      type: RECEIVE_GAME_WIDGET_DATA,
      payload: resultData,
    };
  }
  return {
    type: RECEIVE_GAME_WIDGET_DATA,
    payload: {},
  };
}

function receiveBoardResultData(data) {
  if (data && data.status === 200 && data.data) {
    const resultData = data.data;
    return {
      type: RECEIVE_BOARD_DATA,
      payload: resultData,
    };
  }

  return {
    type: RECEIVE_BOARD_DATA,
    payload: {},
  };
}

function receiveSnippetFilterTabsData(data) {
  if (
    data &&
    (data.parent ||
      (data.childrens instanceof Array && data.childrens.length > 0))
  ) {
    const { parent = {}, childrens = [] } = data;
    return {
      type: RECEIVE_SNIPPET_TABS,
      payload: {
        parent,
        childrens,
      },
    };
  }

  return {
    type: RECEIVE_SNIPPET_TABS,
    payload: {
      parent: {},
      childrens: [],
    },
  };
}

function handleListicleTabsError(error) {
  return {
    type: RECEIVE_LISTICLE_TABS_ERROR,
    error,
  };
}

function handleBoradResultError(error) {
  return {
    type: RECEIVE_BOARD_DATA_ERROR,
    error,
  };
}

function handleGameWidgetError(error) {
  return {
    type: RECEIVE_GAME_WIDGET_DATA_ERROR,
    error,
  };
}

function handleSnippetFilterTabsDataError(error) {
  return {
    type: RECEIVE_SNIPPET_TABS_ERROR,
    error,
  };
}

function fetchLiveblogData(params, isAppView) {
  const appParameter = isAppView ? '&frmapp=yes' : '';
  const isWapView = !!params.isWapView;
  const url = `${getFeedUrl()}/toi/web/show/lb?version=v2&path=/liveblog/${
    params.msid
  }.cms${appParameter}`;
  return makeRequest.get(url, { isMobile: isWapView });
}

export function fetchTimelineData(params) {
  const url = `${TOI_FEED_DOMAIN}/cricket/node/${params.msid}-${
    params.curpg
  }.json`;
  return makeRequest.get(url);
}

export function fetchCompleteTimelineData(params) {
  const url = `${TOI_FEED_DOMAIN}/cricket/node/${params.msid}-allrecord.json`;
  return makeRequest.get(url);
}

export function fetchSnippetFilterTabsData(params) {
  const url = `${CARDCMS_SNIPPET_TABS_URL}${params}.json`;
  // console.log('abcde', url);
  return makeRequest.get(url, 'skipfeedengine');
}

function fetchLiveblogCountData(params) {
  // const url = `http://localhost:3000/testcount.json`
  const url = `${TOI_FEED_DOMAIN}/cricket/node/count-${params.msid}.json`;
  return makeRequest.get(url);
}

// function fetchCardsInsertLite() {
//   return makeRequest.get(
//     `${CARDS_ARTICLESHOW_JSON_URL_V2_LITE}&algorithm_version=v2-mlregression`,
//     'skipfeedengine',
//   );
// }

function getLiveBlogElectionResult(widgets) {
  if (!widgets || widgets.length === 0) {
    return null;
  }
  let electionData = null;
  let widget;
  for (let counter = 0; counter < widgets.length; counter += 1) {
    widget = widgets[counter];
    if (widget.tn === 'resulttable') {
      electionData = {
        feedURL: widget.wu,
      };
      break;
    }
  }

  return electionData;
}

function getLiveBlogExitPollResult(widgets) {
  if (!widgets || widgets.length === 0) {
    return null;
  }
  let electionData = null;
  let widget;
  for (let counter = 0; counter < widgets.length; counter += 1) {
    widget = widgets[counter];
    if (widget.tn === 'exitpolltable') {
      electionData = {
        feedURL: widget.wu,
      };
      break;
    }
  }

  return electionData;
}

function fetchFactsheetListicleTabs(params) {
  const url = `${CARDCMS_LB_TABS_URL}${params.msid}.json`;
  return makeRequest.get(url, 'skipfeedengine');
}

function fetchBoradResultData(metaInfo) {
  const urlBoardResult = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/utility/result/page/init?msid=${
    metaInfo.CARDPAGEID
  }`;
  return makeRequest.get(urlBoardResult, 'skipfeedengine');
}

function fetchGameWidgetData() {
  const urlGameWidget = `${UNIFIED_FEED_DOMAIN_SERVICE}/ufs-utility/toi-games/fetch/game/listing?pc=toi&pfm=web`;
  return makeRequest.get(urlGameWidget, 'skipfeedengine');
}

export function loadLiveblogDataCount(params) {
  return dispatch =>
    fetchLiveblogCountData(params)
      .then(data => dispatch(receiveLiveblogDataCount(data.data, params)))
      .catch(error => dispatch(handleLiveblogDataError(error)));
}

export function loadLiveblogData(params, isAppView) {
  return dispatch =>
    fetchLiveblogData(params, isAppView)
      .then(data => dispatch(receiveLiveblogData(data.data, params)))
      .catch(error => dispatch(handleLiveblogDataError(error)));
}

export function loadTimelineData(params, newCount) {
  return dispatch =>
    fetchTimelineData(params)
      .then(data => dispatch(receiveTimelineData(data.data, params, newCount)))
      .catch(error => dispatch(handleLiveblogDataError(error)));
}

export function loadCompleteTimelineData(params, newCount) {
  return dispatch =>
    fetchCompleteTimelineData(params)
      .then(data =>
        dispatch(receiveCompleteTimelineData(data.data, params, newCount)),
      )
      .catch(error => dispatch(handleCompleteTimelineDataError(error.message)));
}

// export function loadCardInsertLiteData() {
//   return dispatch =>
//     fetchCardsInsertLite()
//       .then(response => {
//         dispatch(receiveCardInsertLiteData(response.data));
//       })
//       .catch(error => {
//         dispatch(handleCardInsertLiteDataError(error));
//       });
// }

export function loadSnippetFilterTabsData(params) {
  return dispatch =>
    fetchSnippetFilterTabsData(params)
      .then(data => dispatch(receiveSnippetFilterTabsData(data.data)))
      .catch(error =>
        dispatch(handleSnippetFilterTabsDataError(error.message)),
      );
}

export function loadTimelineDataPagination(params, count) {
  return dispatch =>
    fetchTimelineData(params)
      .then(data =>
        dispatch(receiveTimelineDataPagination(data.data, params, count)),
      )
      .catch(error => dispatch(handleLiveblogDataError(error)));
}

export function loadFactsheetListicleTabs(params) {
  return dispatch =>
    fetchFactsheetListicleTabs(params)
      .then(data => dispatch(receiveListicleTabsData(data.data)))
      .catch(error => dispatch(handleListicleTabsError(error.message)));
}

export function loadBoardResultData(metaInfo) {
  return dispatch =>
    fetchBoradResultData(metaInfo)
      .then(data => dispatch(receiveBoardResultData(data)))
      .catch(error => dispatch(handleBoradResultError(error.message)));
}

export function loadGameWidgetData() {
  return dispatch =>
    fetchGameWidgetData()
      .then(data => dispatch(receiveGameWidgetData(data)))
      .catch(error => dispatch(handleGameWidgetError(error.message)));
}

// reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_DATA: {
      return {
        ...state,
        quickLinks: action.payload.quickLinks,
        widgets: action.payload.widgets,
        exitPollData: getLiveBlogExitPollResult(action.payload.widgets),
        extraData: getLiveBlogElectionResult(action.payload.widgets),
        seo: action.payload.seo,
        schema: action.payload.schema,
        metaInfo: action.payload.metaInfo,
        ads: action.payload.ads,
        inlineAds: action.payload.inlineAds,
        nextLinks: action.payload.nextLinks,
        images: action.payload.images,
        upd: action.payload.upd,
        dl: action.payload.dl,
        des: action.payload.des,
        slikeId: action.payload.slikeId,
        appdll: action.payload.appdll,
        affKeyword: action.payload.affKeyword,
        navsubsecs: action.payload.navsubsecs,
        newsKws: action.payload.newsKws,
      };
    }
    case RECEIVE_COUNT_DATA: {
      return {
        ...state,
        newCount: action.payload.count,
      };
    }
    case RECEIVE_CARDS_INSERT_LITE_DATA: {
      return {
        ...state,
        cardsInsertsLite: action.payload,
      };
    }
    case HANDLE_CARDS_INSERTS_DATA_LITE_ERROR: {
      return {
        ...state,
        cardsInsertsLite: {},
      };
    }
    case RECEIVE_TIMELINE_DATA: {
      const oldCount =
        action.payload.oldCount ||
        (action.payload.timelineData &&
          action.payload.timelineData.data &&
          action.payload.timelineData.data.totalCount) ||
        0;
      const {
        timelineData: { data: { contents = [] } = {} } = {},
      } = action.payload;
      return {
        ...state,
        timelineData: action.payload.timelineData,
        oldCount,
        count: oldCount,
        contents,
        params: action.payload.params,
      };
    }
    case RECEIVE_COMPLETE_TIMELINE_DATA: {
      const {
        timelineData: { data: { contents = [] } = {} } = {},
      } = action.payload;
      return {
        ...state,
        completeTimelineData: action.payload.timelineData,
        allLiveblogContent: contents,
      };
    }
    case HANDLE_ALL_DATA_ERROR: {
      return {
        ...state,
        completeTimelineData: {},
        allLiveblogContent: [],
        allLiveblogContentError: action.error,
      };
    }
    case RECEIVE_TIMELINE_DATA_PAGINATION: {
      const newCountSt = state.newCount || 0;
      const countSt = state.count || 0;
      let count = 0;
      if (newCountSt > countSt) {
        count = state.count;
      } else {
        count =
          (action.payload.timelineData &&
            action.payload.timelineData.data &&
            action.payload.timelineData.data.totalCount) ||
          action.payload.count ||
          0;
      }
      const {
        timelineData: { data: { contents = [] } = {} } = {},
      } = action.payload;
      const oldContents = state.contents || [];
      const mergedContents = oldContents.concat(contents);
      return {
        ...state,
        count,
        contents: mergedContents,
        params: action.payload.params,
      };
    }
    case RECEIVE_LISTICLE_TABS: {
      return {
        ...state,
        listicletabs: action.payload,
      };
    }
    case RECEIVE_LISTICLE_TABS_ERROR: {
      return {
        ...state,
        listicletabs: [],
        listicletabserror: action.error,
      };
    }
    case RECEIVE_BOARD_DATA: {
      return {
        ...state,
        boardresultdata: action.payload,
      };
    }
    case RECEIVE_BOARD_DATA_ERROR: {
      return {
        ...state,
        boardresultdata: {},
        boardresultdataerror: action.error,
      };
    }
    case RECEIVE_GAME_WIDGET_DATA: {
      return {
        ...state,
        gameWidgetData: action.payload,
      };
    }
    case RECEIVE_GAME_WIDGET_DATA_ERROR: {
      return {
        ...state,
        gameWidgetData: {},
        gameWidgetDataError: action.error,
      };
    }
    case RECEIVE_SNIPPET_TABS: {
      return {
        ...state,
        lbSnippetFilterTabsMeta: action.payload.parent,
        lbSnippetFilterTabs: action.payload.childrens,
      };
    }
    case RECEIVE_SNIPPET_TABS_ERROR: {
      return {
        ...state,
        lbSnippetFilterTabsMeta: {},
        lbSnippetFilterTabs: [],
        lbSnippetFilterError: action.error,
      };
    }
    case SHOW_OPEN_IN_APP: {
      return {
        ...state,
        showOpenInApp: action.payload.show,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
